import { registerRootComponent } from 'expo'
import { createElement } from 'react'
import { createRoot } from 'react-dom/client'
import { Platform } from 'react-native'
import { LogBox } from 'react-native'

import '@adyen/adyen-web/dist/adyen.css'
import App from './src/App'

// Note that this hides the message on the UI, but it will still show on the console.
// Thus, it should be used as a last resort, only if the error/warning cannot really be fixed in any way
// (e.g., if it happens in an external library).
LogBox.ignoreLogs([
  'Warning: Failed prop type: Invalid props.style key `color` supplied to `Image`.',
  //  WARN  Constants.platform.ios.model has been deprecated in favor of expo-device's Device.modelName property. This API will be removed in SDK 45.
  'Constants.platform.ios.model',
])

if (Platform.OS === 'web') {
  const root = createRoot(document.getElementById('root'))
  root.render(createElement(App))
} else {
  registerRootComponent(App)
}
